import * as qsLib from 'qs';

import { handlePagerDutyApiResponse } from 'src/lib/api/handlePagerDutyApiResponse';
import { getEnvironment } from 'src/lib/featureFlags';

import baseApi from '../baseApi';

class Pagerduty {
  constructor() {
    this._accessToken = null;
    this.apiBaseUrl = getEnvironment().apiBaseUrl;
  }

  configure({ accessToken, apiBaseUrl }) {
    if (accessToken !== undefined) this._accessToken = accessToken;
    if (apiBaseUrl !== undefined) this.apiBaseUrl = apiBaseUrl;
  }

  _request({ method, url, body, headers, qs }) {
    if (url.indexOf('http') !== 0) {
      url = this.apiBaseUrl + url;
    }

    const query = qsLib.stringify(qs, { arrayFormat: 'brackets' });
    if (query) {
      if (url.includes('?')) url = `${url}&${query}`;
      else url = `${url}?${query}`;
    }

    headers = headers || {};
    if (!headers.Accept) {
      headers.Accept = 'application/vnd.pagerduty+json;version=2';
    }

    if (!headers.Authorization) {
      if (this._accessToken) {
        headers.Authorization = `Bearer ${this._accessToken}`;
      }
    }

    if (!headers['X-PagerDuty-Client']) {
      headers['X-PagerDuty-Client'] = `"JiraServiceClient" <${location.origin + location.pathname}>`;
    }

    return baseApi
      .regularRequest(method, url, body, headers)
      .then(handlePagerDutyApiResponse);
  }

  async getMe() {
    return this._request({
      url: '/users/me',
      method: 'GET',
    }).then(({ user }) => user);
  }

  async getIncident(id, qs = {}) {
    return this._request({
      url: `/incidents/${id}`,
      method: 'GET',
      qs,
    }).then(({ incident }) => incident);
  }
}

window.__pd_ui_pd_client = window.__cy_stub_pd_ui_pd_client || new Pagerduty();
export default window.__pd_ui_pd_client;
